export default {
  legal_people: [],
  legal_person: null,
  pagination: {}
}
